import { AttachMoneyOutlined } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import {
  useGenerateLead,
  useGetLead,
  useGetProposalInstallments
} from 'modules/orders/hooks'
import { ActionsItemProps } from './actions'
import { useAuth } from 'lib/auth'

export const GenerateFinancialLead = ({
  order,
  disabled
}: ActionsItemProps) => {
  const { mutateAsync: createLead, isLoading: isCreatingLead } =
    useGenerateLead()
  const { mutate: getLead, isLoading: isLoadingLead } = useGetLead()

  const user = useAuth()

  const proposalId = order?.proposalId || ''
  const { data: installments } = useGetProposalInstallments({
    proposalId
  })

  // send last installment only
  const handleCreateLead = async () => {
    const installmentValue =
      installments?.[installments?.length - 1]?.value || 0

    try {
      const data = await createLead({
        borrower: {
          id: order.customer.id,
          name: order.customer.name,
          address: {
            city: order.customer.city,
            state: order.customer.state
          }
        },
        user: {
          name: user.user?.fullName.trim() || '',
          username: user?.user?.username.trim() || '',
          type: 'seller'
        },
        proposalId: order?.proposalId || '',
        financial: {
          amount: installmentValue || 0
        }
      })

      const redirectUrl = data.redirect_url
      window.open(redirectUrl, '_blank')
    } catch (err) {
      console.log(err)
    }
  }

  const handleGetLead = async () => {
    getLead({
      simulationId: order?.simulationId || '',
      name: user.user?.fullName.trim() || '',
      username: user?.user?.username.trim() || '',
      type: 'seller'
    })
  }

  if (order.simulationId) {
    return (
      <MenuItem disabled={isLoadingLead || disabled} onClick={handleGetLead}>
        <AttachMoneyOutlined />
        Abrir Simulação
      </MenuItem>
    )
  }

  return (
    <MenuItem disabled={isCreatingLead || disabled} onClick={handleCreateLead}>
      <AttachMoneyOutlined />
      Gerar Simulação
    </MenuItem>
  )
}
